<template>
  <div class="login-container">
    <el-row type="flex" justify="center">
        <el-col :xl="5">
            <h3 style="text-align:center;">系统登录</h3>
        </el-col>
    </el-row>
    <el-row type="flex" justify="center">
        <el-col :xl="5">
            <el-input v-model="loginForm.username" :clearable="true" @clear="clearUserName" placeholder="用户名"></el-input>
        </el-col>
    </el-row>
    <el-row type="flex" justify="center">
        <el-col :xl="5">
            <el-input v-model="loginForm.password" :clearable="true" placeholder="密码" show-password></el-input>
        </el-col>
    </el-row>
    <el-row type="flex" justify="center">
        <el-col :xl="5">
            <el-button :loading="loading" @click.native.prevent="handleLogin">登录</el-button>
        </el-col>
    </el-row>
  </div>
</template>

<script>

import { login } from "@/api/user.js"

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loading: false,
      info: null
    }
  },
  watch: {
    
  },
  created() {
    
  },
  mounted() {
    
  },
  destroyed() {
    
  },
  methods: {
    handleLogin() {
        this.loading=true
        login(this.loginForm).then(res => {
          localStorage.setItem('token', res.data.token_type + ' ' + res.data.access_token);
          this.loading=false
          this.$router.push('main')
        }).catch(() => {
          this.loading=false
        });
    },
    clearUserName(){
      this.loginForm.username = ''
      this.loginForm.password = ''
    }
  }
}
</script>

<style lang="scss">
  .login-container{
    .el-row {
        margin-bottom: 30px;
    }
    .el-button{
        width: 100%;
    }
  }
</style>